<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--contact"></div>
      <div class="modal__back" @click="goBack()"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form">
        <div class="navigators navigators--company">
          <div class="navigator" @click="currentPage > 0 ? goTo(0) : null" :class="{
            'navigator--active':
              currentPage === 0 ||
              currentPage === 1 ||
              currentPage === 2 ||
              currentPage === 3,
          }">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addCompanyContactModal.${"details"}`) }}</div>
          </div>
          <div class="navigator" @click="goTo(1)" :class="{
            'navigator--active':
              currentPage === 1 || currentPage === 2 || currentPage === 3,
          }">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addCompanyContactModal.${"contact"}`) }}</div>
          </div>
          <div class="navigator" @click="goTo(2)" :class="{
            'navigator--active': currentPage === 2 || currentPage === 3,
          }">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addCompanyContactModal.${"addService"}`) }}</div>
          </div>
          <div class="navigator" @click="goTo(3)" :class="{ 'navigator--active': currentPage === 3 }">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addCompanyContactModal.${"logo"}`) }}</div>
          </div>
        </div>

        <form class="add__form">
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading" />
            <div v-else class="add__content">
              <transition name="fade" mode="out-in">
                <div class="details" key="0" v-if="currentPage === 0">

                  <div class="form__field" v-if="!Object.keys(contactToEdit).length">
                    <MultiSelectDropdown :items="teams" :placeholder="$t('settingsPage.selectTeamPlaceholder')"
                      label="name" :reduce="(team) => team.id" :selected="company.teamIds" class="team-select"
                      :class="{ 'input--error': teamHasError }" @input="company.teamIds = $event" />
                    <div class="form__error" v-if="teamHasError">
                      {{ $t(`addCompanyContactModal.${"teamErrorMsg"}`) }}
                    </div>
                  </div>
                  <div class="form__field">
                    <VSelect class="select select--default" :options="branches" :reduce="(branch) => branch.id"
                      label="name" :placeholder="$t(`addCompanyContactModal.${'branchPlaceholder'}`)"
                      v-model="company.branchId" :class="{ 'select--error': branchHasError }" />
                    <div class="form__error" v-if="branchHasError">
                      {{ $t(`addCompanyContactModal.${"branchErrorMsg"}`) }}
                    </div>
                  </div>
                  <div class="form__field">
                    <input type="text" class="input input--default" :class="{ 'input--error': companyNameHasError }"
                      :placeholder="$t(`addCompanyContactModal.${'companyNamePlaceholder'}`)"
                      v-model="company.companyName" />
                    <div class="form__error" v-if="companyNameHasError">
                      {{ $t(`addCompanyContactModal.${"companyErrorMsg"}`) }}
                    </div>
                  </div>
                  <div class="form__field">
                    <input type="text" class="input input--default"
                      :placeholder="$t(`addCompanyContactModal.${'companyFullNamePlaceholder'}`)"
                      v-model="company.companyFullName" />
                  </div>
                  <div class="form__field">
                    <VSelect class="select select--default" :options="companyTypes" :reduce="(type) => type.id"
                      label="type" :placeholder="$t(`addCompanyContactModal.${'companyTypePlaceholder'}`)"
                      v-model="company.companyType" />
                  </div>
                  <div class="form__field">
                    <div class="details__option">
                      <label class="details__option-name" for="mandateListCheckbox">{{
                        $t(`addCompanyContactModal.${"mandateList"}`) }}</label>
                      <div class="checkbox">
                        <input type="checkbox" id="mandateListCheckbox"
                          :checked="company.mandate_distribution_list === 1" class="checkbox__checkbox"
                          @input="formatCheckbox($event.target.checked, 'mandate_distribution_list')" />
                        <label for="mandateListCheckbox" class="checkbox__label"></label>
                      </div>
                    </div>
                  </div>
                  <div class="form__field">
                    <div class="details__option">
                      <label class="details__option-name" for="viewInAppCheckbox">{{
                        $t(`addCompanyContactModal.${"viewInAppLabel"}`) }}</label>
                      <div class="checkbox">
                        <input type="checkbox" id="viewInAppCheckbox" :checked="company.viewInApp === 1"
                          class="checkbox__checkbox" @input="formatCheckbox($event.target.checked, 'app')" />
                        <label for="viewInAppCheckbox" class="checkbox__label"></label>
                      </div>
                    </div>
                  </div>
                  <div class="form__field">
                    <div class="details__option">
                      <label class="details__option-name" for="statusCheckbox">{{
                        $t(`addCompanyContactModal.${"statusLabel"}`) }}</label>
                      <div class="checkbox">
                        <input type="checkbox" id="statusCheckbox" :checked="company.status === 1"
                          class="checkbox__checkbox" @input="formatCheckbox($event.target.checked, 'status')" />
                        <label for="statusCheckbox" class="checkbox__label"></label>
                      </div>
                    </div>
                  </div>
                  <div class="form__field">
                    <div class="details__option">
                      <textarea class="input input--default"
                        :placeholder="$t(`addCompanyContactModal.${'commentPlaceholder'}`)" rows="4"
                        v-model="company.comment">
                      </textarea>
                    </div>
                  </div>
                </div>

                <div class="contact" key="1" v-else-if="currentPage === 1">
                  <div class="form__field">
                    <input type="text" class="input input--default"
                      :placeholder="$t(`addCompanyContactModal.${'addressPlaceholder'}`)" v-model="company.address" />
                  </div>
                  <div class="form__row">
                    <div class="form__field form__field--double form__field--zip">
                      <input type="text" class="input input--default" :class="{ 'input--error': zipHasError }"
                        :placeholder="$t(`addCompanyContactModal.${'zipPlaceholder'}`)" v-model="company.zip" />
                      <div class="form__error" v-if="zipHasError">
                        {{ $t(`addCompanyContactModal.${"zipErrorMsg"}`) }}
                      </div>
                    </div>
                    <div class="form__field form__field--double">
                      <div class="input input--default input--readonly" v-if="zipCodeData.length === 1">
                        {{ company.city }}
                      </div>
                      <VSelect v-else-if="zipCodeData.length > 1" class="select select--default" :options="zipCodeData"
                        :reduce="(city) => city.city" label="city" v-model="company.city" />
                      <input v-else type="text" class="input input--default"
                        :placeholder="$t(`addCompanyContactModal.${'cityPlaceholder'}`)" v-model="company.city" />
                    </div>
                  </div>
                  <div class="form__field">
                    <VSelect class="select select--default" :options="countries" :reduce="(country) => country.code"
                      label="name" :placeholder="$t(`addCompanyContactModal.${'countryPlaceholder'}`)"
                      v-model="company.country" />
                  </div>
                  <div class="form__field">
                    <input type="text" class="input input--default"
                      :placeholder="$t(`addCompanyContactModal.${'phonePlaceholder'}`)" v-model="company.phone" />
                  </div>
                  <div class="form__field">
                    <input type="text" class="input input--default" placeholder="Fax" v-model="company.fax" />
                  </div>
                  <div class="form__field">
                    <input type="text" class="input input--default" placeholder="Email" v-model="company.email" />
                  </div>
                  <div class="form__field">
                    <input type="email" class="input input--default"
                      :placeholder="$t(`addCompanyContactModal.${'emailMandate'}`)" v-model="company.mandate_email" />
                  </div>
                  <div class="form__field">
                    <input type="text" class="input input--default" placeholder="Web" v-model="company.homepage" />
                  </div>
                </div>

                <div class="services" key="2" v-else-if="currentPage === 2">
                  <div class="form__field">
                    <VSelect class="select select--default" :class="{ 'select--error': servicesHasError }"
                      :options="services" :reduce="(service) => service.id" :label="'name'"
                      :placeholder="$t(`addCompanyContactModal.${'chooseServicesPlaceholder'}`)"
                      @update:modelValue="addService($event)" />
                    <div class="form__error" v-if="servicesHasError">
                      {{ $t(`addCompanyContactModal.${"serviceErrorMsg"}`) }}
                    </div>
                  </div>
                  <div class="tabs tabs--company">
                    <div class="tab" v-for="service in company.services" :key="service">
                      <span>{{
                        services.find((s) => s.id === service)?.[
                        'name'
                        ]
                      }}</span>
                      <div class="tab__delete" @click="removeService(service)"></div>
                    </div>
                  </div>
                </div>

                <div class="logo" key="3" v-else-if="currentPage === 3">
                  <div class="add__avatar">
                    <img :src="companyLogo || defaultBuildingIcon" alt="" />
                  </div>
                  <div class="add__upload-text">
                    {{ $t(`addCompanyContactModal.${"uploadText"}`) }}
                  </div>
                  <div class="add__upload-wrapper">
                    <button type="button" class="button button--default button--upload" @click="uploadFile.click()">
                      {{ $t(`addCompanyContactModal.${"uploadImgBtn"}`) }}
                    </button>
                    <input type="file" ref="uploadFile" class="add__upload" @change="uploadImage($event)" />
                  </div>
                </div>
              </transition>
              <div v-if="isRequesting"
                class="modal__button modal__button--submit button button--default button--loading"></div>
              <div v-else-if="canSubmitCompany">
                <button type="button" class="modal__button modal__button--submit button button--default"
                  @click="currentPage !== 3 ? goForward() : createCompany()">
                  <span v-if="currentPage === 3">{{ $t(`addCompanyContactModal.${"saveBtn"}`) }}</span>
                  <span v-else>{{ $t(`addCompanyContactModal.${"nextBtn"}`) }}</span>
                </button>
              </div>
            </div>
          </transition>
        </form>

        <!-- <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <div v-else-if="canSubmitCompany">
        <button type="button" class="modal__button modal__button--submit button button--default"
          @click="currentPage !== 3 ? goForward() : createCompany()">
          <span v-if="currentPage === 3">{{ $t(`addCompanyContactModal.${"saveBtn"}`) }}</span>
          <span v-else>{{ $t(`addCompanyContactModal.${"nextBtn"}`) }}</span>
        </button>
      </div> -->
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import MultiSelectDropdown from "@/partials/MultiSelectDropdown";
import Loading from "@/partials/Loading";
import defaultBuildingIcon from '../assets/icons/default/Bold 2px-building.svg';
import { useI18n } from 'vue-i18n';

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();
// Component meta description
defineOptions({
  name: "AddCompanyContactModal"
});

const store = useStore();

// Form and flow control refs
const currentPage = ref(0);
const formLoading = ref(false);
const isRequesting = ref(false);
const uploadFile = ref(null);

// Form operational structures
const company = reactive({
  teamIds: [],
  companyName: "",
  companyFullName: "",
  branchId: "",
  companyType: "",
  viewInApp: 0,
  status: 0,
  mandate_email: "",
  mandate_distribution_list: 0,
  comment: "",
  address: "",
  zip: "",
  city: "",
  country: "",
  phone: "",
  fax: "",
  email: "",
  homepage: "",
  services: [],
});

const file = ref("");
const companyLogo = ref("");

// Component validation structures
const teamHasError = ref(false);
const companyNameHasError = ref(false);
const branchHasError = ref(false);
const servicesHasError = ref(false);
const zipHasError = ref(false);

// Store Getters mapped into computeds
const companyForms = computed(() => store.getters.companyForms);
const zipCodeData = computed(() => store.getters.zipCodeData);
const contactToEdit = computed(() => store.getters.contactToEdit);


const companyTypes = computed(() => companyForms.value?.["company-type"] || []);
const branches = computed(() => companyForms.value?.branches || []);
const services = computed(() => companyForms.value?.services || []);
const countries = computed(() => companyForms.value?.countries || []);
const teams = computed(() => {
  if (store.getters.isSuperAdmin) return store.getters.teams || [];

  const authorizedIds = store.getters.authorizedTeamIds("company_access");
  return store.getters.authorizationMemberships
    .filter((membership) => authorizedIds.includes(membership.team.id))
    .map((membership) => membership.team);
});
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canSubmitCompany = computed(() => {
  if (isSuperAdmin.value) return true;

  const isEditing = Object.keys(contactToEdit.value).length > 0;
  const teamContext = isEditing
    ? (
      store.getters.contactToEditTeam
      ?? contactToEdit.value?.team_id
      ?? contactToEdit.value?.team?.id
      ?? contactToEdit.value?.teamId
      ?? company.teamIds?.[0]
      ?? null
    )
    : (company.teamIds?.length ? company.teamIds : []);

  if (isEditing) {
    return teamContext !== null && store.getters.hasTeamPermission("company_edit", teamContext);
  }

  if (!Array.isArray(teamContext) || !teamContext.length) {
    return false;
  }

  return teamContext.some((teamId) => store.getters.hasTeamPermission("company_create", teamId));
});

// Reactive state monitors
watch(() => company.companyName, (value) => {
  companyNameHasError.value = !value;
});

watch(() => company.branchId, (value) => {
  branchHasError.value = !value;
});

watch(() => company.teamIds, (value) => {
  if (!Object.keys(contactToEdit.value).length) {
    teamHasError.value = !(Array.isArray(value) && value.length);
  }
});

watch(() => company.services, (value) => {
  servicesHasError.value = !value.length;
});

watch(() => company.zip, async (zip) => {
  if (zip >= 1000 && zip <= 9999 && zip) {
    zipHasError.value = false;
    await loadCities(zip);
  } else {
    zipHasError.value = true;
  }
});

// Setup actions (Replaces created lifecycle)
const initializeComponent = async () => {
  formLoading.value = true;
  if (store.getters.isSuperAdmin && !store.getters.teams.length) {
    await store.dispatch("getTeams");
  }
  await store.dispatch("getCompanyForms");
  if (Object.keys(contactToEdit.value).length) {
    loadFieldsToEdit();
  }
  formLoading.value = false;
};
initializeComponent();

onUnmounted(() => {
  store.commit("setContactToEdit", {});
});

// Structural internal methods
const closeModal = () => {
  store.commit("setContactToEdit", {});
  store.commit("setContactToEditTeam", null);
  store.commit("setShowAddCompanyContactModal", false);
};

const loadFieldsToEdit = () => {
  const {
    name,
    full_name,
    is_app,
    status,
    comment,
    mandate_email,
    mandate_distribution_list,
    address,
    zip,
    country_code,
    phone,
    fax,
    email,
    web,
    services: contactServices,
    company_type,
    company_type_id,
    branch_id,
    branch,
    logo,
  } = contactToEdit.value;

  company.companyName = name;
  company.companyFullName = full_name;
  company.branchId = branch_id ?? branch?.id ?? branch?.branch_id ?? "";
  company.companyType = company_type?.id ?? company_type ?? company_type_id ?? "";
  company.viewInApp = is_app ? 1 : 0;
  company.status = status ? 1 : 0;
  company.mandate_email = mandate_email || "";
  company.mandate_distribution_list = mandate_distribution_list ? 1 : 0;
  company.comment = comment;
  company.address = address;
  company.zip = zip;
  company.country = country_code;
  company.phone = phone;
  company.fax = fax;
  company.email = email;
  company.homepage = web;
  company.services = contactServices.map((service) => service.id);
  companyLogo.value = logo ? logo.url : "";
};

const goTo = (page) => {
  if (page === 1 || page === 2) {
    validateCompanyDetails((state) => {
      if (state) currentPage.value = page;
    });
  } else if (page === 3) {
    validateCompanyDetails((detailsState) => {
      validateCompanyServices((servicesState) => {
        if (servicesState && detailsState) currentPage.value = page;
      });
    });
  } else {
    currentPage.value = page;
  }
};

const goForward = () => {
  if (currentPage.value < 3) {
    if (currentPage.value === 0 || currentPage.value === 1) {
      validateCompanyDetails((state) => {
        if (state) currentPage.value++;
      });
    } else if (currentPage.value === 2) {
      validateCompanyServices((state) => {
        if (state) currentPage.value++;
      });
    }
  }
};

const validateCompanyDetails = (callback) => {
  const { teamIds, companyName, branchId } = company;

  teamHasError.value = false;
  companyNameHasError.value = false;
  branchHasError.value = false;

  if (!Object.keys(contactToEdit.value).length && (!teamIds || teamIds.length === 0)) {
    teamHasError.value = true;
  }

  if (!companyName) {
    companyNameHasError.value = true;
  }

  if (!branchId) {
    branchHasError.value = true;
  }

  callback(!companyNameHasError.value && !teamHasError.value && !branchHasError.value);
};

const validateCompanyServices = (callback) => {
  const { services: companyServices } = company;
  servicesHasError.value = !companyServices || !companyServices.length;
  callback(!servicesHasError.value);
};

const addService = (serviceId) => {
  if (!company.services.includes(serviceId)) {
    company.services = [...company.services, serviceId];
  }
};

const removeService = (serviceId) => {
  const serviceIndex = company.services.findIndex((id) => id === serviceId);
  if (serviceIndex !== -1) {
    company.services.splice(serviceIndex, 1);
  }
};

const formatCheckbox = (state, type) => {
  const numericState = state ? 1 : 0;
  if (type === "app") {
    company.viewInApp = numericState;
  } else if (type === "status") {
    company.status = numericState;
  } else if (type === "mandate_distribution_list") {
    company.mandate_distribution_list = numericState;
  }
};

const loadCities = async (value) => {
  await store.dispatch("getZipCodeData", value);
  if (zipCodeData.value.length) {
    company.city = zipCodeData.value[0].city;
  } else {
    company.city = "";
  }
};

const uploadImage = (event) => {
  file.value = event.target.files[0];
  companyLogo.value = URL.createObjectURL(file.value);
};

const createCompany = async () => {
  const isEditing = Object.keys(contactToEdit.value).length > 0;
  const permissionTeamId = isEditing
    ? (
      store.getters.contactToEditTeam
      ?? contactToEdit.value?.team_id
      ?? contactToEdit.value?.team?.id
      ?? contactToEdit.value?.teamId
      ?? company.teamIds?.[0]
      ?? null
    )
    : company.teamIds?.[0] ?? null;

  if (!isEditing && !company.teamIds?.length) {
    teamHasError.value = true;
    return;
  }

  if (isEditing && permissionTeamId === null) {
    return;
  }

  if (isEditing && !isSuperAdmin.value && !store.getters.hasTeamPermission("company_edit", permissionTeamId)) {
    return;
  }

  if (!isEditing && !isSuperAdmin.value && !store.getters.hasTeamPermission("company_create", permissionTeamId)) {
    return;
  }

  isRequesting.value = true;
  validateCompanyDetails(async (detailsState) => {
    validateCompanyServices(async (servicesState) => {
      if (detailsState && servicesState) {
        company.file = file.value;
        if (!Object.keys(contactToEdit.value).length) {
          await store.dispatch("addCompany", company);
        } else {
          try {
            const response = await store.dispatch("updateCompany", {
              ...company,
              companyId: contactToEdit.value.id,
              name: company.companyName,
              companyType: company.companyType,
              branchId: company.branchId,
            });

            const updatedCompany = response?.data?.data || response?.data;

            if (updatedCompany) {
              store.commit("setSelectedCompany", updatedCompany);
            }

            if (file.value) {
              store.dispatch("addCompanyLogo", { companyId: updatedCompany.id, file: file.value });
            }

            store.commit("setSelectedCompany", updatedCompany);
          } catch (err) {
            // Error already handled by store action
          }
        }

        // if (contactToEditTeam.value) {
        //   await store.dispatch("getCompanies", contactToEditTeam.value);
        // } else {
        //   await store.dispatch("getCompanies", company.teamIds[0]);
        // }

        if (Object.keys(contactToEdit.value).length) {
          // Editing: just refresh the single company
          store.commit("setIsUpdatingCompany", true);

          try {
            const response = await store.dispatch(
              "getCompany",
              contactToEdit.value.id
            );

            const updatedCompanyData = response?.data || response;

            if (updatedCompanyData) {
              store.commit("setSelectedCompany", updatedCompanyData);
            }
          } finally {
            store.commit("setIsUpdatingCompany", false);
          }
        } else {
          // Adding: refresh all companies for the team
          store.commit("setIsUpdatingCompany", true);

          try {
            if (company.teamIds && company.teamIds.length) {
              await store.dispatch("getCompanies", company.teamIds[0]);
            }
          } finally {
            store.commit("setIsUpdatingCompany", false);
          }
        }

        closeModal();
        isRequesting.value = false;
      } else {
        isRequesting.value = false;
      }
    });
  });
};
</script>

<style lang="scss" scoped>
.details {
  &__option {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-name {
      color: var(--text-2);
      font-family: var(--muli-text-semi-bold);
      font-size: var(--x-small);
    }
  }
}

.form__field--zip {
  margin-right: 5px;
}

.team-select {
  border-radius: 10px !important;
}


textarea {
  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  height: auto;
  resize: none;
  padding: 12px;
}

@media screen and (max-width: 500px) {
  .customer__form .form .tabs--company {
    position: relative;
    left: initial;
    right: initial;
    top: initial;
    transform: none;
  }
}
</style>
